import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import useSWR from "swr";
import CreateBooking from "../../pages/CreateBooking/CreateBooking";
import BookingForm from "../BookingForm/BookingForm";
import { multiFormatUploader, fetcher } from "../../../../services/fetcher";
import { mutate } from "swr";
import { errorNotifications, successNotifications } from "../../../../utils/handleNotifications";
import { Paper, Select } from "@mantine/core";
import { OperatorProfile_API, BOOKINGS_API } from '../../../../api/endpoints';

const BulkBookingForm = () => {
  const [issueAs, setIssueAs] = useState("User");
  const [selectedCover, setSelectedCover] = useState(null);
  const [selectedOperator, setSelectedOperator] = useState(null);
  const navigate = useNavigate();

  const { data: operatorListData } = useSWR(OperatorProfile_API, fetcher);

  const operatorOptions = useMemo(() => {
    const operators = Array.isArray(operatorListData)
      ? operatorListData
      : operatorListData?.results ?? [];
    const seen = new Set();
    const options = operators.reduce((acc, op) => {
      const name = String(op?.operator_name || "Unnamed Operator");
      if (seen.has(name)) return acc;
      seen.add(name);
      acc.push({ value: name, label: name });
      return acc;
    }, []);

    return [...options, { value: "others", label: "Others" }];
  }, [operatorListData]);

  const addBookingMutation = async (booking) => {
    try {
      const payload = { ...booking };
      
      // Add cover_id from selected cover
      if (selectedCover?.value) {
        payload.cover_price_id = selectedCover.value;
      }
      
      // Add operator_details from selected operator
      if (selectedOperator) {
        const selectedOpData = operatorListData?.results?.find(
          (op) => op?.operator_name === selectedOperator
        );
        payload.operator_details = selectedOpData?.id || selectedOperator?.id;
      }
      
      // If "others" is selected, use custom_operator_name instead
      if (payload.client_or_operator === "others" && payload.custom_operator_name) {
        payload.client_or_operator = payload.custom_operator_name;
      }
      if (!payload.client_or_operator && selectedOperator) {
        payload.client_or_operator = selectedOperator;
      }
      // Always remove this field before sending
      delete payload.custom_operator_name;
      await multiFormatUploader(BOOKINGS_API, "POST", payload);
      successNotifications("Success! Booking added");
      mutate(BOOKINGS_API);
      navigate(-1);
    } catch (error) {
      errorNotifications(error.response?.data || "Something went wrong", error);
    }
  };
  
  return (
    <> 
      {/* {selectedCover && ( */}
        <Paper shadow="md" p="lg" mt="lg" mb="lg">
        <Select
          label="Operator Name"
          placeholder="Select an operator"
          rules={{ required: "Operator Name is required" }}
          searchable
          clearable
          withAsterisk 
          data={operatorOptions}
          value={selectedOperator || ""}
          onChange={(value) => setSelectedOperator(value || null)}
        />
        <CreateBooking 
          selectedValue={issueAs} 
          onChange={(e) => setIssueAs(e.target.value)} 
          selectedCover={selectedCover} 
          setSelectedCover={setSelectedCover} 
          policyType="bulk"
        />
        {/* integrate here */}
        <BookingForm
          onSubmit={addBookingMutation}
          selectedCover={selectedCover}
          bookingType="BULK"
          hideFields={["client_or_operator"]}
          selectedOperator={selectedOperator}
        />
      </Paper>
      {/* )} */}
    </>
  );
};

export default BulkBookingForm;